"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Select;
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _formik = require("formik");
var S = _interopRequireWildcard(require("./styles"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function Select({
  disabled = false,
  error,
  label,
  name,
  options,
  required = false,
  ...rest
}) {
  const [field, meta] = (0, _formik.useField)(name);
  const errorMessage = meta.touched && meta.error || error;
  return /*#__PURE__*/_react.default.createElement(S.Label, {
    $error: !!errorMessage,
    $disabled: disabled,
    htmlFor: name
  }, label, label && required && ' *', /*#__PURE__*/_react.default.createElement(S.Arrow, {
    $error: !!errorMessage
  }, /*#__PURE__*/_react.default.createElement(S.Select, _extends({}, field, rest, {
    id: name,
    $error: !!errorMessage
  }), /*#__PURE__*/_react.default.createElement(S.Option, {
    hidden: required,
    label: "None",
    value: ""
  }, "None"), _lodash.default.map(options, option => /*#__PURE__*/_react.default.createElement(S.Option, {
    key: option.value,
    label: option.label,
    value: option.value
  }, option.value)))), !!errorMessage && /*#__PURE__*/_react.default.createElement(S.Error, null, errorMessage));
}